import $ from 'jquery'
import { getElement } from '../utils/functional'

export default class CardFilter {
  constructor (el) {
    $('.shd-Search_Input').keyup(function () {
      const filter = $(this)
        .val()
        .toUpperCase()

      $(this)
        .parent()
        .parent()
        .parent()
        .parent()
        .parent()
        .find('.sec-Shades_Items .sec-Shades_Item')
        .each(function () {
          if (
            $(this)
              .text()
              .toUpperCase()
              .indexOf(filter) > -1
          ) {
            $(this)[0].style.display = ''
            $(this).each(function () {
              if (
                $(this)
                  .text()
                  .toUpperCase()
                  .indexOf(filter) > -1
              ) {
                $(this).show()
              } else {
                $(this).hide()
              }
            })
          } else {
            $(this)[0].style.display = 'none'
          }
        })
    })
  }
}
